import React from "react";
import clsx from "classnames";
import { useSelector } from "react-redux";

const myStyle = ["text-info", "font-weight-bolder", "mx-1"].join(" ");

const IndemnityForm = ({ superCorporate }) => {
    const layoutType = useSelector((state) => state.appReducer.layoutType);
    const baseClass = clsx("text-justify p-3", {
        "bg-dark text-white": layoutType === "dark"
    });
    return (
        <div className={baseClass} style={{ lineHeight: 1.5 }}>
            <p>
                This INDEMNITY is provided by <span className={myStyle}>{superCorporate}</span> to
                eTRANZACT INTERNATIONAL PLC{" "}
            </p>
            <p>
                IN CONSIDERATION of <span className={myStyle}>{superCorporate}</span> not accepting
                to utilize the Multi-factor authentication functionality to secure user access on
                the CorporatePay Platform of eTRANZACT,
            </p>
            <p>
                <span className={myStyle}>{superCorporate}</span> hereby irrevocably and
                unconditionally warrant, declare and agree as follows
            </p>
            <ol className="p-0 ml-2 indemnity-list">
                <li>
                    That <span className={myStyle}>{superCorporate}</span> hereby irrevocably and
                    unconditionally indemnify eTranzact and keep eTranzact, its directors, staff and
                    agents indemnified against all litigations, actions and proceedings for which
                    <span className={myStyle}>{superCorporate}</span>, its directors, staff and
                    agents may be liable or losses which may be suffered by
                    <span className={myStyle}>{superCorporate}</span>, its directors, staff and
                    agents or claims which may be incurred or made against
                    <span className={myStyle}>{superCorporate}</span>, its directors, staff or agent
                    as a result of or pursuant to
                    <span className={myStyle}>{superCorporate}</span> non-consenting to utilize the
                    multi-factor authentication Service on the corporatepay platform;
                </li>
                <li>
                    That <span className={myStyle}>{superCorporate}</span> shall fully and solely be
                    responsible for all risks, claims, losses, damages and fraudulent transactions
                    of any nature that may arise from
                    <span className={myStyle}>{superCorporate}</span> disabling the multi-factor
                    authentication Service on the corporatepay platform;
                </li>
                <li>
                    That <span className={myStyle}>{superCorporate}</span> further fully indemnify
                    eTranzact, its Directors, agents, privies, assigns, successors, employees, or
                    any other person whomsoever acting under eTranzact’s authority or control
                    against any costs, losses, damages, expenses (including Attorney’s fees),
                    judicial awards of any kind, or any payments of whatsoever nature made or any
                    cost however incurred, whether directly or indirectly, remotely or otherwise for
                    non-consenting to utilize the multi-factor authentication Service on the
                    corporatepay platform;
                </li>
                <li>
                    That <span className={myStyle}>{superCorporate}</span> affirm that all
                    approvals, consents and authorizations necessary for the discharge of
                    <span className={myStyle}>{superCorporate}</span> obligations under this
                    Indemnity have been obtained, are valid and in full force and effect;
                </li>
                <li>
                    That <span className={myStyle}>{superCorporate}</span> further affirm that the
                    persons executing this Indemnity on {superCorporate}
                    behalf are as at the date hereof are duly appointed, empowered and authorized to
                    bind <span className={myStyle}>{superCorporate}</span> in connection with the
                    subject matter hereof;
                </li>
                <li>
                    That no amendment, modification or release from any provision(s) of this
                    Indemnity hereof is valid except with the prior written consent of eTranzact,
                    neither shall <span className={myStyle}>{superCorporate}</span> assign or
                    transfer any of their obligations under this Undertaking/Indemnity whether by
                    operation of the law or otherwise to any third party without the prior written
                    consent of eTranzact.
                </li>
            </ol>
            <p>
                This Indemnity shall take effect from the date of approval of request to disable the
                multi-factor authentication functionality on corporatePay and shall remain valid and
                in full force.
            </p>
            <p>
                This Indemnity shall be construed in all respects in accordance with the Laws of the
                Federal Republic of Nigeria as may be in force from time to time.
            </p>
        </div>
    );
};

export default IndemnityForm;
